
export default function HeroSection() {
  const scrollToForm = () => {
    const element = document.getElementById('request-sample');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-[60vh] sm:min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/1e3c7b765a19fcb1e6a2428b45655394.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>

      <div className="relative z-10 w-full max-w-[680px] mx-auto px-4 sm:px-6 text-center text-white py-6 sm:py-16">
        {/* Headline */}
        <h1 
          className="font-bold mb-2 sm:mb-4 leading-[1.15] tracking-tight text-[22px] sm:text-[clamp(28px,3.8vw,44px)]"
          style={{ 
            fontWeight: 700
          }}
        >
          Keep families connected with a facility-branded monthly magazine — sponsored locally.
        </h1>
        
        {/* Subheadline - hidden on mobile */}
        <p className="hidden sm:block text-base mb-5 leading-relaxed max-w-[600px] mx-auto opacity-95">
          We handle editorial, design, print + digital delivery, sponsor sales, billing, and disclosures. Your team only reviews the final proof (~10–15 min/month).
        </p>

        {/* Checklist - hidden on mobile */}
        <div className="hidden sm:block mb-5 space-y-2 max-w-[540px] mx-auto">
          <div className="flex items-start justify-center text-left gap-2">
            <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-sm"></i>
            </span>
            <span className="text-base">Monthly stories, events, and activities residents enjoy</span>
          </div>
          <div className="flex items-start justify-center text-left gap-2">
            <span className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-sm"></i>
            </span>
            <span className="text-base">Branded to your facility in print + digital</span>
          </div>
        </div>

        {/* Compliance badges - smaller on mobile */}
        <div className="flex flex-wrap items-center justify-center gap-1.5 sm:gap-2 mb-4 sm:mb-6 text-[10px] sm:text-xs">
          <span className="bg-black/35 backdrop-blur-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap border border-white/20">
            No PHI collected
          </span>
          <span className="bg-black/35 backdrop-blur-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap border border-white/20">
            Sponsorships labeled
          </span>
          <span className="bg-black/35 backdrop-blur-sm px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap border border-white/20">
            Not medical advice
          </span>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3">
          <button
            onClick={scrollToForm}
            className="w-full sm:w-auto bg-gradient-to-r from-[#6B4EFF] to-[#FF4D7D] text-white px-5 sm:px-7 py-3 sm:py-3.5 rounded-lg text-sm sm:text-base font-semibold hover:from-[#5A3EEE] hover:to-[#EE3C6C] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Request a sample issue
          </button>
          <a
            href="https://calendly.com/harmony-horizon"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white border-2 border-white px-5 sm:px-7 py-3 sm:py-3.5 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer inline-block text-center"
          >
            Book a 15-min call
          </a>
        </div>
      </div>
    </div>
  );
}
